import { Box, styled } from "@mui/material";
import { StandardDialog } from "../../../components/dialogs/standard-dialog/standard-dialog";

export const IconContainer = styled(Box)`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 6px;

  @media screen and (max-width: 768px) {
    flex-direction: column;

    div {
      margin-top: 6px;
      margin-left: 0;
    }
  }
`;

export const HeadUl = styled("ul")`
  display: flex;
  align-items: center;
  justify-content: start;
  list-style: none;
  padding: 0;

  li:first-of-type {
    padding-top: 46px;
  }

  li {
    flex: 1;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
  }
`;

export const BodyUl = styled("ul")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  gap: 4px;
  padding: 0;
  border-radius: 8px;
  overflow: hidden;

  li {
    flex: 1;
    font-size: 14px;
    text-align: left;
    background: #f1f1fb;
    padding: 10px;
  }
`;

export const DialogWrapper = styled(StandardDialog)`
  
.MuiDialog-paper {
  max-width: 940px;
  margin: 82px 32px 32px;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    margin: 66px 0 0;
  }

  .MuiPaper-root {
    box-shadow: none;
  }

  .shipping-items {
    padding-left: 0;
    padding-right: 10px;
  }

  .modal-close {
    width: 150px;
    align-self: flex-end;
    margin: 10px;
  }
}
`;
